import { useMemo } from 'react';
import { useHoveredTs } from '../../../components/focus/hovered-ts-ctx';
import { StreamDiarization } from './StreamDiarization';
import {
  formatFragmentsHover,
  parseTranscription,
} from '../../../components/audit/transcriptions/utils';
interface Props {
  diarization: any[];
}

export function HoveredDiarization({ diarization }: Props) {
  const ts = useHoveredTs();

  const parsedData: any[] = useMemo(
    () => formatFragmentsHover(diarization ? parseTranscription(diarization) : []),
    [diarization],
  );

  if (!ts) {
    return null;
  }

  return <StreamDiarization data={parsedData} ts={ts} />;
}
